import _ from 'lodash';

const isEmptyOrOnlySpace = (value: string) => _.isEmpty(value) || /^[\s]+$/.test(value);

export default isEmptyOrOnlySpace;
